// TODO(tim): improve on our color scheme and possibly we'll need different
// alpha values for different aspects so using a string might not be the
// best option here.

import { customColorsRaw } from '@apollo/orbit';

export const possibleColors: MinLengthArray<1, string> = [
  // Start with error-related color
  customColorsRaw.icon.error,
  customColorsRaw.icon.secondary,
  customColorsRaw.icon.beta,
  customColorsRaw.icon.info,
  customColorsRaw.icon.change,
  customColorsRaw.icon.warning,
  // Additional colors if needed
  customColorsRaw.brand.primary,
  customColorsRaw.brand.tertiary,
  customColorsRaw.code.b,
  customColorsRaw.code.c,
  customColorsRaw.code.d,
  customColorsRaw.code.f,
  customColorsRaw.code.g,
];

export function groupColorForIndex(idx: number): string {
  return possibleColors[idx % possibleColors.length] ?? possibleColors[0];
}
